/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `ACLS` - ACLS (Advanced Cardiac Life Support)
 * * `ATLS` - ATLS (Advanced Life Trauma Support)
 * * `BLS` - BLS (Basic Life Support)
 * * `PALS` - PALS (Pediatric Advanced Life Support)
 * * `NRP` - NRP (Neonatal Resuscitation Program)
 * * `OTHER` - Other
 */
export enum CertificationTypeEnum {
    ACLS = 'ACLS',
    ATLS = 'ATLS',
    BLS = 'BLS',
    PALS = 'PALS',
    NRP = 'NRP',
    OTHER = 'OTHER',
}
